const dropdown = document.getElementById("dropdownBtn");

if (dropdown){
    dropdown.addEventListener("click", showItem);
}

function showItem() {
    const showCollapse = document.getElementById("collapse");
    const icon = document.getElementById("collapse-icon");
    showCollapse.classList.toggle("collapse-show")

    icon.classList.toggle("icon-rotate")
}

const select = document.getElementById("selectBtn");

if (select){
    select.addEventListener("click", showSelectItem);
}

function showSelectItem() {
    const showCollapse = document.getElementById("select");
    showCollapse.classList.toggle("select-item-show")
}

// ✅ Toggle button text on click

const showMoreButtons = document.querySelectorAll(".dropdownBtn");


//let searchBtn = document.querySelectorAll('.search-link-label');

//searchBtn.forEach(button => {
//    button.addEventListener("click", function() {
//        searchBtn.forEach(btn => btn.classList.remove('search-link-label-active'));
//        this.classList.add('search-link-label-active');
//    });
//});

  

showMoreButtons.forEach(function (showMoreButton){
    showMoreButton.addEventListener('click', function handleClick() {

    const showMoreButtonTexts = showMoreButton.querySelectorAll(".dropdownBtn span")
        showMoreButtonTexts.forEach(function (showMoreButtonText){
        const initialText = 'Show Less';

        // const showText = showMoreButton.children;

            if (showMoreButtonText.textContent.toLowerCase().includes(initialText.toLowerCase())) {
            showMoreButtonText.textContent = 'Show More';
            } else {
            showMoreButtonText.textContent = initialText;
            }
        })
    })
});

// Listing Reveal Phone Number 
const reveal = document.getElementById("reveal");

if (reveal){
    reveal.addEventListener("click", revealItem);
}
function revealItem() {
    const revealItems = document.getElementById("reveal");
    revealItems.classList.add("d-none")
}


const revealSm = document.getElementById("reveal-sm");

if (revealSm){
    revealSm.addEventListener("click", revealItemSm);
}
function revealItemSm() {
    const revealItems = document.getElementById("reveal-sm");
    revealItems.classList.add("d-none")
}



// Vacancy List on Listing

const readMoreBtns = document.querySelectorAll(".vacancy-desc-wrapper");

if (readMoreBtns){
    function toggleFullWidth(vacancyDesc) {
        const heightExpands = vacancyDesc.querySelector("#vacancy-desc");
        heightExpands.classList.toggle("h-transform")
    }
    readMoreBtns.forEach(function (readMoreBtn) {
        readMoreBtn.addEventListener('click', function handleClick() {

            toggleFullWidth(readMoreBtn)

            const readMoreBtnTexts = readMoreBtn.querySelectorAll(".vacancy-item-readmore span")

            readMoreBtnTexts.forEach(function (readMoreBtnText) {
                const initialText = 'Read less';

                if (readMoreBtnText.textContent.toLowerCase().includes(initialText.toLowerCase())) {
                readMoreBtnText.textContent = 'Read more';
                } else {
                readMoreBtnText.textContent = initialText;
                }
            })
        })
    })

}

//Modal Backdrop

const modalShows = document.querySelectorAll('[data-bs-toggle="modal"]')

if(modalShows){
    modalShows.forEach(function (modalShow) {
        modalShow.addEventListener('click', function handleClick() {

            const modalBackdrops = document.querySelectorAll(".modal-backdrop")
            if(modalBackdrops.length > 1) {

                modalBackdrops.forEach(function (modalBackdrop) {
                    modalBackdrop.classList.add("modal-backdrop-twice")
                })
            }
        })
    })
}

//lightbox
// const lightboxs = document.querySelectorAll(".lightbox-modal-container");

// if (lightboxs){
//     function toggleModal(lightboxModalCarousel) {
//         const lightboxModal = lightboxModalCarousel.querySelector("#lightbox-modal");
//         lightboxModal.classList.toggle("d-block")
//     }
//     lightboxs.forEach(function (lightbox) {
//         lightbox.addEventListener('click', function handleClick() {
//             toggleModal(lightbox)     
//         })
//     })

// }



// const modalBackdrop = document.querySelectorAll(".modal-backdrop").length

// console.log(modalBackdrop)
export default {};
